import { Platform } from '@angular/cdk/platform';
import { ChangeDetectionStrategy, Component, EventEmitter, Output, inject } from '@angular/core';

import { TerraIconModule } from '@ninety/terra';

@Component({
  selector: 'ninety-mobile-banner',
  standalone: true,
  templateUrl: './mobile-banner.component.html',
  styleUrls: ['./mobile-banner.component.scss'],
  imports: [TerraIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.ninety-mobile-banner--ios-safari]': '_isIosSafari',
  },
})
export class NinetyMobileBannerComponent {
  private readonly _platform = inject(Platform);

  @Output() readonly dismiss: EventEmitter<void> = new EventEmitter<void>();

  private ANDROID_URL = 'https://play.google.com/store/apps/details?id=io.ninety.mobile';
  private IOS_URL = 'https://apps.apple.com/us/app/ninety/id6743240706';

  protected _isIosSafari = this._platform.IOS && this._platform.SAFARI;
  protected _appUrl: string | undefined;

  constructor() {
    if (this._platform.ANDROID) {
      this._appUrl = this.ANDROID_URL;
    } else if (this._platform.IOS) {
      this._appUrl = this.IOS_URL;
    }
  }

  protected _dismiss() {
    this.dismiss.emit();
  }
}
